import _construct from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/construct";
import $ from 'dom7';
export default function () {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultSelector = parameters.defaultSelector,
      constructor = parameters.constructor,
      domProp = parameters.domProp,
      app = parameters.app,
      addMethods = parameters.addMethods;
  var methods = {
    create: function create() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (app) return _construct(constructor, [app].concat(args));
      return _construct(constructor, args);
    },
    get: function get() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSelector;
      if (el instanceof constructor) return el;
      var $el = $(el);
      if ($el.length === 0) return undefined;
      return $el[0][domProp];
    },
    destroy: function destroy(el) {
      var instance = methods.get(el);
      if (instance && instance.destroy) return instance.destroy();
      return undefined;
    }
  };

  if (addMethods && Array.isArray(addMethods)) {
    addMethods.forEach(function (methodName) {
      methods[methodName] = function () {
        var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSelector;
        var instance = methods.get(el);

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        if (instance && instance[methodName]) return instance[methodName].apply(instance, args);
        return undefined;
      };
    });
  }

  return methods;
}